import { Flex } from '@/ui/Flex/Flex';
import CustomSwitch from '@/ui/Switch/Switch';
import { T } from '@/ui/Text/Text';
import { useIntl } from 'react-intl';
import React from 'react';

type CodeEditingSwitchProps = {
  isSaving: boolean;
  savingScript: boolean;
  isEditingCode: boolean;
  setIsEditingCode: React.Dispatch<React.SetStateAction<boolean>>;
};
function CodeEditingSwitch({
  isSaving,
  savingScript,
  isEditingCode,
  setIsEditingCode,
}: CodeEditingSwitchProps) {
  const intl = useIntl();
  return (
    <Flex gap={8} align="center">
      <T body1>
        {intl.formatMessage({
          defaultMessage: 'Enable Code Editing (Developer Mode)',
          id: 'Dgm4QG',
        })}
      </T>
      <CustomSwitch
        disabled={isSaving || savingScript}
        checked={isEditingCode}
        onChange={() => setIsEditingCode(!isEditingCode)}
        testId="code-editing-switch"
      />
    </Flex>
  );
}
export default CodeEditingSwitch;
